<template>
<div class="container container--reset-padding" v-bind:class="{'spacer': numResults < 1}">
    <p v-if="numResults > 0">{{i18n_strings.verified_desc}}</p>
</div>
</template>

<style lang="scss" scoped="true">
    .container {
        &.spacer {
            height: 300px;
        }
        p {
            font-size: 15px;
            margin-bottom: 110px;
        }
    }
</style>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Verified",
    props: {
        "numResults": Number
    },
    computed: {
        ...mapGetters([
            'i18n_strings',
        ])
    }
}
</script>
